import {EventTheme} from 'types/types';

const events: EventTheme[] = [
  {
    theme: 'cinema',
    description: 'Кино',
    eventList: [
      {
        year: 1905,
        description: 'Показан первый черно-белый художественный фильм о Шерлоке Холмсе.'
      },
      {
        year: 1908,
        description: 'В царской Росиии выпущена короткометражная драма “Выбор царской невесты» Василия Гончарова.'
      },
      {
        year: 1913,
        description: 'Вышел немой короткометражный фильм «Дети капитана Гранта» режиссера Викторен Жассе.'
      },
      {
        year: 1915,
        description: 'В Москве основано кинематографическое предприятие «Русь».'
      },
      {
        year: 1945,
        description: 'Фильм «Сердца четырёх» режиссера Константина Юдина занимает 3-е место в лидерах проката.'
      },
      {
        year: 1948,
        description: 'Проходит 21-я премия Оскар, где лучшим фильмом выбран «Гамлет» Лоренса Оливье.'
      },
      {
        year: 1950,
        description: 'Walt Disney выпускает на экраны мультфильм «Золушка».'
      },
      {
        year: 1954,
        description: 'Оскар присуждается фильму «Отныне и во веки веков» Бадди Адлер.'
      },
      {
        year: 1955,
        description: 'Нашумевшая премьера фильма в СССР «Укротительница тигров».'
      },
      {
        year: 1960,
        description: '«Сладкая жизнь» Федерико Феллини победила на Каннском кинофестивале.'
      },
      {
        year: 1962,
        description: 'Стал выпускаться сатирический художественный киножурнал «Фитиль».'
      },
      {
        year: 1965,
        description: 'Состоялась 10-я церемония вручения наград премии «Давид Дима Донателло».'
      },
      {
        year: 1969,
        description: '1 января состоялась премьера мультфильма «Ну, погоди!».'
      },
      {
        year: 1970,
        description: 'На экраны вышел совместный итало-франко-советский фильм «Подсолнухи».'
      },
      {
        year: 1980,
        description: 'Проведена первая церемония объявления лауреатов премии «Золотая малина».'
      },
      {
        year: 1983,
        description: 'Дон Аллан основал кинокомпанию "Revolver Film Company".'
      },
      {
        year: 1988,
        description: 'На экраны выходит фильм «Игла» с Виктором Цойем в главной роли.'
      },
      {
        year: 1989,
        description: 'Появляется внутристудийная премия Ленфильма «Медный всадник».'
      },
      {
        year: 1994,
        description: 'Экранизация романа Михаила Булгакова «Мастер и Маргарита».'
      },
      {
        year: 1997,
        description: 'Рекорды кинопроката бьет фильм-катастрофа «Титаник».'
      },
      {
        year: 2001,
        description: 'Весь мир отправляется в волшебную школу с фильмом «Гарри Поттер и философский камень».'
      },
      {
        year: 2004,
        description: 'Выпущен полнометражный японский мультфильм «Ходячий замок».'
      },
      {
        year: 2015,
        description: 'Премия «Золотой глобус» за фильм на иностранном языке получает «Левиафан».'
      },
      {
        year: 2016,
        description: 'Выходит фильм о вселенной Гарри Поттера «Фантастические твари и где они обитают».'
      },
      {
        year: 2021,
        description: '1-ая вручения наград премии Critics Choice Super Awards.'
      },
      {
        year: 2022,
        description: 'Оскар за лучший фильм получает «CODA: Ребёнок глухих родителей».'
      },
    ]
  },
  {
    theme: 'literature',
    description: 'Литература',
    eventList: [
      {
        year: 1906,
        description: 'В Российской империи был издан первый том Европейской энциклопедии «Брокгауза и Ефрона».'
      },
      {
        year: 1909,
        description: 'Первое издание легендарного романа Джека Лондона «Мартин Иден».'
      },
      {
        year: 1911,
        description: 'В Санкт-Петербурге увидел свет первый том «Военной энциклопедии».'
      },
      {
        year: 1912,
        description: 'Опубликован роман Эдуарда Берроуза «Тарзан, приёмыш обезьян».'
      },
      {
        year: 1916,
        description: 'Карл Густав Вернен Фон Хейденстам получает Нобелевскую премию мира «как виднейший представитель новой эпохи в мировой литературе».'
      },
      {
        year: 1917,
        description: 'Корней Чуковский написал первую поэму «Крокодил» из серии сборников для детей.'
      },
      {
        year: 1945,
        description: 'Впервые опубликован роман Эриха Мария Ремарк «Триумфальная арка».'
      },
      {
        year: 1947,
        description: 'Пулитцеровскую премию получает Роберт Пенн Уоррен за роман «Вся королевская рать».'
      },
      {
        year: 1949,
        description: 'Написан «1984» - культовая утопия Джорджа Оруэлла, ставшая зеркалом для многих стран с их политическим режимом.'
      },
      {
        year: 1951,
        description: 'Мир встречает "Над пропастью во ржи" Сэллинджера, получивший в последствие Пулитцеровскую премию за данную работу.'
      },
      {
        year: 1952,
        description: 'Эрнест Хемингуэй создает повесть «Старик и море».'
      },
      {
        year: 1953,
        description: 'Учреждение премии «Хьюго» в области научной фантастики.'
      },
      {
        year: 1954,
        description: 'Первая публикация романа-эпопеи Дж.Толкина «Властелин колец». Можете поверить в это?'
      },
      {
        year: 1955,
        description: 'В СССР начинают выходить в печать журналы «Юность» и «Иностранная литература».'
      },
      {
        year: 1960,
        description: 'Выходит роман Харпера Ли «Убить пересмешника». Число его переизданий достигнет более 7 млн. копий.'
      },
      {
        year: 1962,
        description: 'Выходит роман Кена Кизи «Пролетая над гнездом кукушки». Считается одним из главных литературных произведений движений битников и хиппи.'
      },
      {
        year: 1963,
        description: 'Написан первый том романа Джона Фаулза «Коллекционер». Он входит в британскую версию «100 лучших детективных романов всех времён».'
      },
      {
        year: 1965,
        description: 'Учреждение премии «Небьюла». Наградами Nebula ежегодно отмечают лучшие произведения научной фантастики или фэнтези, опубликованные в Соединённых Штатах.'
      },
      {
        year: 1966,
        description: 'Первая публикация мистического романа Михаила Булгакова «Мастер и Маргарита». Примечательно, писать роман Булгаков начала в декабре 1928 года и продолжал вплоть до своей смерти.'
      },
      {
        year: 1967,
        description: 'В свет вышло художественно-историческое приведение Александра Солженицына «Архипелаг ГУЛАГ».'
      },
      {
        year: 1969,
        description: 'В ФРГ впервые опубликована на русском языке пьеса Николая Эрдмана «Самоубийца». Одна из первых «чёрных комедий» в литературе.'
      },
      {
        year: 1982,
        description: 'Всемирную премию фэнтези получил Джон Кроули за роман «Маленький, большой».'
      },
      {
        year: 1983,
        description: 'Стивен Кинг выпускает свой бестселлер «Кладбище домашних животных».'
      },
      {
        year: 1985,
        description: 'Написан роман Габриэля Гарсиа Маркеса «Любовь во время холеры».'
      },
      {
        year: 1986,
        description: 'В Норвегии учреждена премия для драматургов «Премия Ибсена».'
      },
      {
        year: 1987,
        description: 'Нобелевская премия по литературе вручается Иосифу Александровичу Бродскому.'
      },
      {
        year: 1991,
        description: 'Опубликована трилогия Сирии романов «Дневники вампиров» Лизы Джейн Смит.'
      },
      {
        year: 1995,
        description: 'Букеровскую премию получает Пэт Баркер за произведение «Дорога призраков».'
      },
      {
        year: 1997,
        description: 'Выходит первый роман серии Джоан Роулинг «Гарри Поттер и философский камень».'
      },
      {
        year: 2000,
        description: 'В Российской Федерации учреждена независимая литературная премия «Дебют».'
      },
      {
        year: 2003,
        description: 'Увидел свет роман Одри Ниффенеггер «Жена путешественника во времени».'
      },
      {
        year: 2005,
        description: 'Опубликовывается роман Виктора Пелевина «Шлем Ужаса».'
      },
      {
        year: 2016,
        description: 'Нобелевская премия по литературе присуждена Бобу Дилану за роман "Человек дождя".'
      },
      {
        year: 2017,
        description: 'Букеровская премия присуждается писателю Джорджу Сондерсу за роман «Линкольн в бардо».'
      },
      {
        year: 2019,
        description: 'Вышел дебютный роман Элизабет Гилберт «Город Женщин».'
      },
      {
        year: 2020,
        description: 'Из-за пандемии коронавируса отменены все книжные ярмарки в Европе.'
      },
      {
        year: 2021,
        description: 'Британский писатель Энтони Браун награждён Орденом Британской империи.'
      }
    ]
  },
  {
    theme: 'persons',
    description: 'Личности',
    eventList: [
      {
        year: 1962,
        description: '21 февраля 1962 года родился американский писатель Чак Паланик. Через 34 года он шокирует литературный мир своим "Бойцовским клубом".'
      },
      {
        year: 1994,
        description: 'Умирает американский писатель Чарльз Буковски. Очередь проститься с творцом растянулась на 11 километров.'
      },
      {
        year: 1906,
        description: '25 сентября родился великий русский композитор Дмитрий Шостакович.'
      },
      {
        year: 1914,
        description: '31 июля родился Луи де Фюнес, французский киноактёр, кинорежиссёр и сценарист испанского происхождения, один из величайших комиков мирового кино.'
      },
      {
        year: 1916,
        description: '15 июля умер известный биолог Илья Мечников. Лауреат Нобелевской премии в области физиологии и медицины (1908).'
      },
      {
        year: 1945,
        description: '6 февраля родился ямайский музыкант Боб Марли. Являлся самым известным исполнителем в стиле регги.'
      },
      {
        year: 1949,
        description: '15 апреля родилась примадонна российской эстрады Алла Пугачева. "Миллион алых роз", пожалуй, знают все наизусть.'
      },
      {
        year: 1951,
        description: '12 декабря родился русский путешественник Фёдор Конюхов. В одиночку совершил пять кругосветных плаваний, 17 раз пересёк Атлантику, причём один раз на вёсельной лодке.'
      },
      {
        year: 1953,
        description: '17 мая родился президент Республики Казахстан Косым-Жомарт Токаев. Второй и нынешний президент РК.'
      },
      {
        year: 1962,
        description: '5 августа скончалась американская кинозвезда Мэрилин Монро. Она была одним из наиболее культовых образов американского кинематографа и всей мировой культуры.'
      },
      {
        year: 1965,
        description: '31 июля родилась писательница и "мама" Гарри Поттера Джоан Роулинг.'
      },
      {
        year: 1968,
        description: '27 марта погибает в авиационной катастрофе первый космонавт мира Юрий Алексеевич Гагарин. Прости, Юра, мы...'
      },
      {
        year: 1980,
        description: '26 августа родился актёр, сыгравший Кевина в «Один дома» Маколей Калкин. Эта роль станет наиболее успешной в карьере актера.'
      },
      {
        year: 1987,
        description: '17 декабря скончался советский актёр, юморист Аркадий Райкин. Его миниатюры и спектакли отличались сатирической остротой, особенно в сравнении с другими артистами эстрады того времени.'
      },
      {
        year: 1991,
        description: '24 ноября умер композитор и вокалист группы "Queen" Фредди Меркьюри.'
      },
      {
        year: 1994,
        description: '5 апреля совершает самоубийство вокалист группы «Nirvana” Курт Кобейн.'
      },
      {
        year: 1997,
        description: '25 июня умер путешественник, исследователь океана Жак-Ив-Кусто.'
      },
      {
        year: 2001,
        description: '18 декабря появилась на свет американская певица и автор песен Billie Ellish.'
      },
      {
        year: 2004,
        description: '19 февраля родилась "11" из сериала «Очень странные дела» Милли Бобби Браун.'
      },
      {
        year: 1998,
        description: '12 мая умер певец, лауреат премии «Оскар» и «Гремми» Фрэнк Синатра.'
      },
      {
        year: 2015,
        description: '2 мая родилась член британской королевской семьи Принцесса Шарлотта Кембриджская.'
      },
      {
        year: 2016,
        description: '14 января скончался актёр, сыгравший профессора Снейпа в фильмах о «Гарри Поттере» Алан Рикман.'
      },
      {
        year: 2017,
        description: '10 ноября умер российский писатель,комик и сатирик Михаил Задорнов.'
      },
      {
        year: 2018,
        description: '14 марта скончался английский физик-теоретик и астрофизик Стивен Хокинг.'
      },
      {
        year: 2020,
        description: '4 мая в семье Илона Маска родился ребёнок с необычным именем X Æ A-12.'
      },
      {
        year: 2022,
        description: '8 сентября скончалась королева Великобритании, которая правила 70 лет Елизавета II.'
      }
    ]
  },
  {
    theme: 'science',
    description: 'Наука',
    eventList: [
      {
        year: 1905,
        description: 'Карл фон Линде получил жидкие кислород и азот путём охлаждения воздуха.'
      },
      {
        year: 1910,
        description: 'Марии Склодовской-Кюри впервые в мире удалось выделить металлический радий из его соли и подробно изучить его свойства.'
      },
      {
        year: 1911,
        description: 'Норвежский полярный исследователь Руал Амундсен с четырьмя спутниками впервые в истории достиг Южного полюса.'
      },
      {
        year: 1913,
        description: 'Ханс Гейгер изобрёл счётчик Гейгера, способный измерять радиоактивность.'
      },
      {
        year: 1917,
        description: 'Запущен в работу первый супертелескоп (100-дюймовый телескоп Хокера) в обсерватории Маунт-Вильсон.'
      },
      {
        year: 1945,
        description: 'Нобелевскую премию получил Вольфганг Паули, «За открытие принципа запрета Паули»'
      },
      {
        year: 1948,
        description: 'Американским астрономом Джерардом Койпером открыта Миранда, спутник Урана.'
      },
      {
        year: 1950,
        description: 'Чикагский хирург Ричард Лоулер за 45 минут выполнил первую операцию по пересадке почки человеку.'
      },
      {
        year: 1952,
        description: 'Совершил первый полёт американский стратегический бомбардировщик B-52 «Стратофортресс».'
      },
      {
        year: 1954,
        description: 'Запуск первой в Советском Союзе атомной электростанции.'
      },
      {
        year: 1955,
        description: 'В воздух поднялся первый советский реактивный пассажирский самолёт Ту-104.'
      },
      {
        year: 1960,
        description: 'Советский Союз запускает «Спутник-5», на борту которого находились собаки Белка и Стрелка.'
      },
      {
        year: 1961,
        description: 'Юрий Гагарин становится первым человеком в космосе.'
      },
      {
        year: 1965,
        description: 'Эдвард Уайт стал первым американским астронавтом, вышедшим в открытый космос.'
      },
      {
        year: 1967,
        description: 'В госпитале Грут Шут, Кейптаун (ЮАР) проведена первая в истории медицины операция по пересадке сердца.'
      },
      {
        year: 1969,
        description: 'Экипаж «Аполлон-11» совершил первую в истории человечества высадку на Луну.'
      },
      {
        year: 1975,
        description: 'Проведён советско-французский эксперимент АРАКС по созданию искусственного полярного сияния.'
      },
      {
        year: 1981,
        description: 'В Лос-Анджелесе (США) зарегистрированы первые 5 случаев «редкой формы пневмонии» (позднее получившей название СПИД).'
      },
      {
        year: 1982,
        description: 'В Германии общественности представлены первые компакт-диски (CD).'
      },
      {
        year: 1985,
        description: 'Учёные из British Antarctic Survey впервые обнаружили озоновую дыру.'
      },
      {
        year: 1990,
        description: 'На орбиту запущен крупнейший космический телескоп "Хаббл".'
      },
      {
        year: 1994,
        description: 'Международный сетевой центр InterNIC официально зарегистрировал национальный домен .ru'
      },
      {
        year: 1996,
        description: 'Клонирование овечки Долли. Эксперимент завершился удачно, но, увы, жизнь Долли не продлилась долго.'
      },
      {
        year: 1997,
        description: 'В Массачусетском технологическом институте под руководством В. Кеттерле создан первый атомный лазер.'
      },
      {
        year: 2001,
        description: 'Компания «Intel» представила новый процессор «Pentium 4».'
      },
      {
        year: 2004,
        description: 'Андреем Геймом и Константином Новосёловым изобретён способ получения графена.'
      },
      {
        year: 2005,
        description: 'Компанией «КриоРус» успешно крионирован первый россиянин — Лидия Ивановна Федоренко.'
      },
      {
        year: 2015,
        description: 'Американская частная компания SpaceX осуществила первое в истории управляемое приземление ракеты-носителя.'
      },
      {
        year: 2016,
        description: 'На МКС впервые расцвело растение, это была декоративная цинния.'
      },
      {
        year: 2017,
        description: 'Компания Tesla официально представила первый в мире электрический грузовик Tesla Semi.'
      },
      {
        year: 2019,
        description: 'Google объявил о создании 53-кубитного квантового компьютера.'
      },
      {
        year: 2020,
        description: 'Вторая женщина Ванесса О’Брайен покорила Марианскую впадину, став первой в мире женщиной, покорившей Эверест и глубочайшую точку Земли.'
      },

    ]
  },
  {
    theme: 'tragedy',
    description: 'Трагедии',
    eventList: [
      {
        year: 1906,
        description: '18 апреля произошло землетрясение в Сан-Франциско, разрушившее 80 % зданий в городе и унесшее жизни более 3000 человек.'
      },
      {
        year: 1907,
        description: '21 февраля произошло одно из крупнейших кораблекрушений XX века: во время шторма потерпел крушение пароход «Берлин», погибло 129 человек.'
      },
      {
        year: 1909,
        description: 'С 14 по 27 апреля произошла массовая резня армян вилайетов Адана и Аллепо, организованная турецкими властями. Были убиты около 21 тыс. человек.'
      },
      {
        year: 1911,
        description: '18 февраля произошёл крупнейший обвал объёмом 2,2 млрд м³ на реке Мургаб, в результате которого образовались естественная плотина и Сарезское озеро.'
      },
      {
        year: 1912,
        description: '15 апреля британский лайнер «Титаник» потерпел крушение в результате столкновения с айсбергом. Погибли 1496 человек.'
      },
      {
        year: 1916,
        description: '21 декабря во время шторма в Северном море столкнулись и затонули два британских эсминца «Негро» и «Хост»,на первом корабле погиб 196 военнослужащий, на втором 80.'
      },
      {
        year: 1946,
        description: '5 ноября серия авиакатастроф во Внуково: в плохих погодных условиях в течение часа разбились два самолёта Ли-2 и один C-47, погибли 19 человек.'
      },
      {
        year: 1948,
        description: '6 октября произошло сильное землетрясение в Ашхабаде и окружающих районах. Ашхабад был почти полностью разрушен, погибло около 110 тыс. человек.'
      },
      {
        year: 1950,
        description: '9 января произведен расстрел демонстрации рабочих в Модене. В результате столкновения с полицией убито 6 и ранено 30 человек. На следующий день объявлена 24-часовая национальная забастовка.'
      },
      {
        year: 1953,
        description: '15 апреля в Буэнос-Айресе во время выступления президента Аргентины Хуана Перона перед президентским дворцом взорвана бомба. Убито 6, ранено 92 человека.'
      },
      {
        year: 1955,
        description: '11 июня произошла самая крупная авария за всю историю автоспорта: на легендарном 24-часовом марафоне автомобиль Mercedes-Benz упал на трибуны, что повлекло за собой гибель 84 человек.'
      },
      {
        year: 1960,
        description: 'Одна из крупнейших в истории аварий на угольной шахте — из-за взрыва метана погибли 437 шахтёров на шахте «Coalbrook» под Йоханнесбургом в ЮАР.'
      },
      {
        year: 1962,
        description: '3 июня в парижском аэропорту Орли при взлёте разбился Boeing 707, погибли 130 человек. Первая катастрофа реактивного самолёта с более чем 100 погибшими.'
      },
      {
        year: 1965,
        description: '17 апреля в США за сутки было зафиксировано 78 торнадо. Погибло 271 человек, около 1500 человек пострадали.'
      },
      {
        year: 1970,
        description: '22 июля произошёл теракт, взрыв железнодорожного экспресса сообщением Палермо-Турин близ Реджо-ди-Калабрии. Погибли 6 человек.'
      },
      {
        year: 1972,
        description: '26 января катастрофа самолета DC-9 над Хермсдорфом, погибли 27 человек. После падения с высоты 10 160 метров осталась жива стюардесса Весна Вулович.'
      },
      {
        year: 1975,
        description: '21 декабря группа террористов во главе с Ильичом Рамиресом Санчесом («Карлос Шакал») захватила более 90 участников встречи стран ОПЕК, включая министров из 11 стран.'
      },
      {
        year: 1980,
        description: '27 марта в результате катастрофы норвежской нефтяной платформы «Александр Килланд» погибли 123 человека из 212.'
      },
      {
        year: 1981,
        description: '8 февраля 19 болельщиков футбольного клуба «Олимпиакос» погибли и 54 получили травмы во время давки на стадионе Караискаки в Пирее.'
      },
      {
        year: 1983,
        description: '18 августа На побережье Техаса, обрушился ураган «Алисия», погибло 22 человека, нанесён ущерб в 3,8 млрд долларов.'
      },
      {
        year: 1986,
        description: '26 апреля произошёл взрыв реактора 4-го энергоблока Чернобыльской атомной электростанции, крупнейшая атомная техногенная авария.'
      },
      {
        year: 1989,
        description: '7 апреля советская атомная подводная лодка К-278 «Комсомолец» затонула в результате пожара в Норвежском море, погибли 42 моряка.'
      },
      {
        year: 1991,
        description: '15 июня произошло второе по силев XX веке извержение вулкана Пинатубо на Филиппинах. Количество жертв превысило 800 человек.'
      },
      {
        year: 1994,
        description: '17 января произошло Сильное землетрясение в южных районах штата Калифорния. Погибли 60 человек, около 20 000 жителей остались без крова.'
      },
      {
        year: 1996,
        description: '21 января у берегов северной Суматры из-за перегруза потерпел крушение пассажирский паром «Гурита» , жертвами катастрофы стали 340 человек.'
      },
      {
        year: 1998,
        description: '15 августа в результате самого кровавого теракта в Оме за время конфликта в Северной Ирландии погибло 29 человек, свыше 220 получили ранения.'
      },
      {
        year: 2000,
        description: 'Выброс в Дунай более 100 тыс. кубометров тяжёлых металлов на заводе румыно-австралийской компании «Аурул». В результате аварии, было выловлено более 100 тонн мёртвой рыбы.'
      },
      {
        year: 2001,
        description: '11 сентября произошла крупнейшая террористическая атака в США. Был уничтожен Всемирный торговый центр, погибло порядка трёх тысяч человек.'
      },
      {
        year: 2004,
        description: '26 декабря произошло крупнейшее землетрясение в Индийском океане у берегов Юго-Восточной Азии. В результате цунами погибли около 230 тысяч человек.'
      },
      {
        year: 2015,
        description: 'В результате крупных пожаров в Хакасии, возникших в степных регионах, сгорели более 1200 домов в 42 населённых пунктах, погибли 36 человек, около 5 тысяч человек остались без жилья.'
      },
      {
        year: 2016,
        description: '5 июня в Актобинске (Казахстан) произошёл захват оружейных магазинов и воинской части. В результате перестрелки 7 человек погибли, 38 человек ранены, 13 террористов были уничтожены.'
      },
      {
        year: 2017,
        description: '4 апреля произошло поражение населения химическими отравляющими веществами в сирийском городе Хан-Шейхун. Погибли 74 человека, ранены 557 человек.'
      },
      {
        year: 2018,
        description: '16 февраля произошло землетрясение в Мексике магнитудой 7,2 балла. Погибли 14 человек, около 1 млн домов остались без электроэнергии.'
      },
      {
        year: 2020,
        description: '7 января в Иране был сбит пассажирский самолёт Boeing 737-800 Международные авиалинии Украины, летевший из Тегерана в Киев рейсом PS 752, все находившиеся 176 человек на борту погибли.'
      },
      {
        year: 2022,
        description: '29 октября 2 заминированных автомобиля взорвались у здания Минобразования Сомали в Могадишо. Не менее 100 человек погибли, 300 пострадали.'
      },
    ]
  },
  {
    theme: 'music',
    description: 'Музыка',
    eventList: [
      {
        year: 1905,
        description: 'Премьера симфонической поэмы Арнольда Шёнберга «Пеллеас и Мелисанда» в Вене.'
      },
      {
        year: 1907,
        description: 'Премьера оперы Фредерика Делиуса «Сельские Ромео и Джульетта» в Берлине.'
      },
      {
        year: 1912,
        description: 'В последний раз проводится Бирмингемский фестиваль классической музыки.'
      },
      {
        year: 1916,
        description: 'В Копенгагене Карл Нильсен дирижировал на премьере своей симфонии №4 «Неудержимая».'
      },
      {
        year: 1917,
        description: 'Первые джазовые записи, сделанные Original Dixieland Jass Band.'
      },
      {
        year: 1945,
        description: 'В Риге была учреждена первая в Латвии музыкальная школа для особо одарённых детей.'
      },
      {
        year: 1948,
        description: 'Выпущен альбом Christmas Songs by Sinatra (Фрэнк Синатра).'
      },
      {
        year: 1953,
        description: 'Фрэнк Синатра подписывает семилетнее соглашение с звукозаписывающей компанией Capitol Records.'
      },
      {
        year: 1955,
        description: 'Выпущен альбом Satch Plays Fats (Луи Армстронг).'
      },
      {
        year: 1960,
        description: 'Выходит первый альбом Адриано Челентано «Adriano Celentano con Giulio Libano e la sua orchestra»'
      },
      {
        year: 1963,
        description: 'Самый продаваемый сингл в США «Surfin’ U.S.A.» (The Beach Boys)'
      },
      {
        year: 1967,
        description: 'Pink Floyd впервые выступает с квадрофоническим звуком на концерте в холле Королевы Элизабетты.'
      },
      {
        year: 1973,
        description: 'Алла Пугачёва становится солисткой Москонцерта.'
      },
      {
        year: 1975,
        description: 'В Лондоне основана британская панк-рок-группа Sex Pistols.'
      },
      {
        year: 1981,
        description: 'Брэд Уитфорд ушёл из «Aerosmith» а его место занял Рик Дьюфей.'
      },
      {
        year: 1984,
        description: 'У «Queen» вышел одиннадцатый студийный альбом «The Works».'
      },
      {
        year: 1987,
        description: 'Арета Франклин стала первой женщиной, чьё имя было занесено в Зал славы рок-н-ролла.'
      },
      {
        year: 1989,
        description: 'Дебютный одноимённый альбом канадского гитариста и клавишника Альдо Новы («Aldo Nova», 1982) стал платиновым.'
      },
      {
        year: 1990,
        description: 'Рок-группа «Кино» прекратила своё существование в связи с гибелью лидера — Виктора Цоя...'
      },
      {
        year: 1994,
        description: 'Nirvana отыграли свой финальный концерт в Мюнхене.'
      },
      {
        year: 1999,
        description: 'Брюс Диккинсон и Адриан Смит вернулись в состав хэви-метал группы Iron Maiden.'
      },
      {
        year: 2000,
        description: 'Начала своё вещание первая российская альтернативная радиостанция ULTRA.'
      },
      {
        year: 2001,
        description: 'Бас-гитарист Джейсон Ньюстед покидает группу Metallica после 14 лет совместной работы.'
      },
      {
        year: 2003,
        description: 'Группа «Тату» успешно покоряет Запад и выступает на конкурсе Евровидение 2003 в городе Рига.'
      },
      {
        year: 2005,
        description: 'В Дублине был установлен памятник бас-гитаристу «Thin Lizzy» Филу Лайнотту.'
      },
      {
        year: 2016,
        description: 'ABBA воссоединилась на один день в золотом составе.'
      },
      {
        year: 2017,
        description: 'Концерты Depeche Mode в Санкт-Петербурге и Москве в рамках Global Spirit Tour.'
      },
      {
        year: 2018,
        description: 'Норвежский музыкальный проект Burzum прекращает свою деятельность.'
      },
      {
        year: 2020,
        description: 'Первая отмена «Евровидения» за всю его историю из-за пандемии COVID-19.'
      },
      {
        year: 2021,
        description: 'Певица Земфира выпустила первый за 8 лет альбом «Бордерлайн».'
      }
    ]
  }
];

export {events};
